import { render } from "./FormattableField.vue?vue&type=template&id=334c7f2e&ts=true"
import script from "./FormattableField.vue?vue&type=script&lang=ts"
export * from "./FormattableField.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__